// extracted by mini-css-extract-plugin
export default {"dialog":"SendCodePopup_dialog__Sanyf","dialogContent":"SendCodePopup_dialogContent__mAtZh","buttonsContaine":"SendCodePopup_buttonsContaine__rRHNn"};